<template>
  <div class="card">
    <div class="card-body p-0">
      <div
        v-if="this.errosValidacaoGeral.length"
        class="notice d-flex bg-light-danger rounded border-danger border border-dashed mx-9 mt-9 p-6"
      >
        <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
          <inline-svg src="media/icons/duotune/general/gen044.svg" />
        </span>
        <div class="d-flex flex-stack flex-grow-1">
          <div class="fw-bold">
            <h4 class="text-gray-800 fw-bolder">Aviso</h4>
            <div class="fs-6 text-gray-600">
              <ul>
                <li v-for="value in this.errosValidacaoGeral" :key="value">
                  {{ value }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="card-header border-0 pt-5">
        <div class="card-title">
          <div class="d-flex align-items-center position-relative my-1">
            <span class="svg-icon svg-icon-1 position-absolute ms-6">
              <inline-svg src="media/icons/duotune/general/gen004.svg" />
            </span>
            <input
              id="txtPesquisarInutilizacoes"
              type="text"
              v-model="tableData.search"
              @input="onSearch($event.target.value)"
              class="form-control form-control-solid ps-15"
              placeholder="Pesquisar Inutilizações"
            />
          </div>
        </div>
        <div class="card-toolbar flex-row-fluid justify-content-end gap-5">
          <button
            @click="this.adicionarInutilizacaoNFe()"
            type="button"
            class="btn btn-sm btn-primary"
            v-if="this.adicionar"
          >
            <span class="svg-icon svg-icon-2">
              <inline-svg src="media/icons/duotune/general/gen041.svg" />
            </span>
            Adicionar
          </button>
        </div>
      </div>
      <div class="card-body pt-0">
        <Datatable
          ref="tabelaInutilizacoesNFe"
          :table-header="tableHeader"
          :table-data="tableData"
          :table-pagination="tablePagination"
          :page-sizes="pageSizes"
          :enable-items-per-page-dropdown="true"
          :hide-on-single-page="false"
          empty-table-text="Nenhuma inutilização encontrada"
          :colors="true"
        >
          <template v-slot:cell-id="{ row: inutilizacao }">
            {{ inutilizacao.id }}
          </template>
          <template v-slot:cell-situacao="{ row: inutilizacao }">
            <span
              :class="[
                inutilizacao && inutilizacao.cod_status === 102
                  ? 'badge badge-success'
                  : 'badge badge-warning',
              ]"
              >{{
                inutilizacao && inutilizacao.cod_status === 102
                  ? "Inutilizada"
                  : "Pendente"
              }}</span
            >
          </template>
          <template v-slot:cell-ano="{ row: inutilizacao }">
            {{ inutilizacao.ano }}
          </template>
          <template v-slot:cell-modelo="{ row: inutilizacao }">
            {{ inutilizacao.modelo }}
          </template>
          <template v-slot:cell-serie="{ row: inutilizacao }">
            {{ inutilizacao.serie }}
          </template>
          <template v-slot:cell-n_nf_ini="{ row: inutilizacao }">
            <div class="text-dark fw-bolder min-w-80px">
              {{ inutilizacao.n_nf_ini }}
            </div>
          </template>
          <template v-slot:cell-n_nf_fin="{ row: inutilizacao }">
            <div class="text-dark fw-bolder min-w-80px">
              {{ inutilizacao.n_nf_fin }}
            </div>
          </template>
          <template v-slot:cell-justificativa="{ row: inutilizacao }">
            {{ inutilizacao.justificativa }}
          </template>
          <template v-slot:cell-protocolo="{ row: inutilizacao }">
            {{ inutilizacao.protocolo }}
          </template>
          <template v-slot:cell-cod_status="{ row: inutilizacao }">
            {{ inutilizacao.cod_status }}
          </template>
          <template v-slot:cell-desc_status="{ row: inutilizacao }">
            {{ inutilizacao.desc_status }}
          </template>
          <template v-slot:cell-createdAt="{ row: inutilizacao }">
            <div class="min-w-100px">
              {{ this.$utils.formatarData(inutilizacao.createdAt) }}
            </div>
          </template>
          <template v-slot:cell-updatedAt="{ row: inutilizacao }">
            <div class="min-w-100px">
              {{ this.$utils.formatarData(inutilizacao.updatedAt) }}
            </div>
          </template>
          <template v-slot:cell-acoes="{ row: inutilizacao }">
            <div class="d-flex justify-content-end flex-shrink-0">
              <button
                class="btn btn-sm btn-light btn-active-light-primary d-flex align-items-center"
                data-kt-menu-trigger="click"
                data-kt-menu-placement="bottom-end"
                data-kt-menu-flip="top-end"
                tabindex="-1"
              >
                Ações
                <span class="svg-icon svg-icon-5 m-0">
                  <inline-svg src="media/icons/duotune/arrows/arr072.svg" />
                </span>
              </button>
              <div
                class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-150px py-4"
                data-kt-menu="true"
              >
                <div class="menu-item px-3" v-if="this.editar">
                  <a
                    @click="editarInutilizacaoNFe(inutilizacao)"
                    class="menu-link px-3"
                    ><span class="svg-icon svg-icon-1 align-self-center">
                      <inline-svg
                        src="media/icons/duotune/art/art005.svg"
                        class="me-2"
                      />Editar
                    </span>
                  </a>
                </div>
                <div class="menu-item px-3" v-if="this.excluir">
                  <a
                    @click="removerInutilizacaoNFe(inutilizacao)"
                    class="menu-link px-3"
                    ><span class="svg-icon svg-icon-1 align-self-center">
                      <inline-svg
                        src="media/icons/duotune/arrows/arr015.svg"
                        class="me-2"
                      />Excluir
                    </span></a
                  >
                </div>
                <div class="menu-item px-3" v-if="this.transmitir">
                  <a
                    @click="transmitirInutilizacao(inutilizacao)"
                    class="menu-link px-3"
                    ><span class="svg-icon svg-icon-1 align-self-center">
                      <inline-svg
                        src="media/icons/duotune/general/gen016.svg"
                        class="me-2"
                      />Transmitir
                    </span></a
                  >
                </div>
              </div>
            </div>
          </template>
        </Datatable>
      </div>
    </div>
  </div>
  <LoadingModal
    :nomeRef="'loadingModalInutilizacaoNFe'"
    :mensagem="this.mensagemLoading"
    v-if="this.loading === true"
  ></LoadingModal>
  <ErroNFeModal
    v-if="exibirModalErroNFe"
    :erroOriginal="this.erroOriginal"
    :erroFormatado="this.erroFormatado"
    @exibirModalErroNFe="modalErroNFe"
  ></ErroNFeModal>
  <EditarInutilizacaoNFeModal
    v-if="exibirModalInutilizacaoNFe"
    :refInutilizacaoNFeEdicao="this.refInutilizacaoNFeEdicao"
    :id="this.idInutilizacaoNFe"
    @exibirEditarInutilizacaoNFeModal="exibirEditarInutilizacaoNFeModal"
    @confirmarEditarInutilizacaoNFeModal="confirmarEditarInutilizacaoNFeModal"
  >
  </EditarInutilizacaoNFeModal>
</template>

<script>
import { getOrCreateInstanceModal, hideModalId } from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import Datatable from "@/components/kt-datatable/KTDatatableCustom.vue";
import LoadingModal from "@/components/modals/general/LoadingModal.vue";
import { mapState } from "vuex";
import { useToast } from "vue-toastification";
import ErroNFeModal from "@/views/gerenciarnfe/ErroNFeModal.vue";
import EditarInutilizacaoNFeModal from "@/views/gerenciarnfe/EditarInutilizacaoNFeModal.vue";

const toast = useToast();
export default {
  components: {
    Datatable,
    LoadingModal,
    ErroNFeModal,
    EditarInutilizacaoNFeModal,
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
    async verificarRestricoes() {
      if (this.user.User.EmitenteTipoUsuario.EmitenteRestricao != null) {
        this.user.User.EmitenteTipoUsuario.EmitenteRestricao.find((element) => {
          if (element.regra === "Permitir.InutilizacaoNFe.Incluir") {
            this.adicionar = true;
          }
          if (element.regra === "Permitir.InutilizacaoNFe.Alterar") {
            this.editar = true;
          }
          if (element.regra === "Permitir.InutilizacaoNFe.Excluir") {
            this.excluir = true;
          }
          if (element.regra === "Permitir.InutilizacaoNFe.Transmitir") {
            this.transmitir = true;
          }
        });
      }
    },
    onSearch(pesquisa) {
      if (pesquisa !== "") {
        pesquisa = pesquisa.replace("'", "''");
        this.tableData.filterOData =
          "&$filter=contains(n_nf_ini, '" +
          pesquisa +
          "') or contains(n_nf_ini, '" +
          pesquisa +
          "') or contains(n_nf_fin, '" +
          pesquisa +
          "') or contains(modelo, '" +
          pesquisa +
          "') or contains(serie, '" +
          pesquisa +
          "') ";
        if (this.$utils.isNumber(pesquisa)) {
          this.tableData.filterOData =
            this.tableData.filterOData + " or id eq " + pesquisa;
        }
      } else {
        this.tableData.filterOData = "";
      }
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async exibirModalLoading(exibir, callback) {
      if (exibir === true) {
        this.loading = true;
        getOrCreateInstanceModal(
          "loadingModalInutilizacaoNFe",
          /*open*/ null,
          /*close*/ null
        );
      } else {
        hideModalId("loadingModalInutilizacaoNFe", () => {
          this.loading = false;
          this.$nextTick(() => {
            if (callback) {
              callback();
            }
          });
        });
      }
    },
    async transmitirInutilizacao(inutilizacao) {
      if (inutilizacao.cod_status != 102) {
        await this.$swal.showQuestionAlert(
          "Deseja transmitir a inutilização selecionada?",
          async (alert) => {
            if (alert.isConfirmed) {
              try {
                this.loading = true;
                this.mensagemLoading = "Transmitindo a inutilização";
                await this.exibirModalLoading(true);

                let result = await this.$store.dispatch(
                  "gerenciadorNFe/inutilizarNFe",
                  inutilizacao.id
                );

                if (result && result.Success === true) {
                  if (result.Data && result.Data.XMotivo) {
                    let mensagem =
                      result.Data.CStat + " - " + result.Data.XMotivo;

                    this.$refs.tabelaInutilizacoesNFe.setLoading(true);
                    this.$refs.tabelaInutilizacoesNFe.load();
                    await this.$swal.showSuccessAlert(mensagem);
                  }
                } else {
                  if (result.Data) {
                    if (result.Data.InfInut && result.Data.InfInut.CStat) {
                      let mensagem =
                        result.Data.InfInut.CStat +
                        " - " +
                        result.Data.InfInut.XMotivo;
                      await this.exibirMensagemErroSimplificada(mensagem);
                    } else if (result.Data && result.Data.CStat) {
                      let mensagem =
                        result.Data.CStat + " - " + result.Data.XMotivo;
                      await this.exibirMensagemErroSimplificada(mensagem);
                    } else {
                      await this.$swal.showInvalidAlert(result.Mensagem);
                    }
                  } else {
                    await this.$swal.showInvalidAlert(result.Mensagem);
                  }
                }
              } catch (error) {
                if (error.Message) {
                  await this.$swal.showInvalidAlert(error.Mensagem);
                } else {
                  var mensagemFormatada = await this.$utils.formatarMensagem(
                    error
                  );
                  if (mensagemFormatada !== "") {
                    this.erroOriginal = error;
                    this.erroFormatado = mensagemFormatada;
                    await this.modalErroNFe(true);
                  }
                }
              }
              await this.exibirModalLoading(false);
              this.loading = false;
              this.mensagemLoading = "";
            }
          }
        );
      } else {
        await this.$swal.showInvalidAlert(
          "O status indica que a numeração já foi inutilizada."
        );
      }
    },
    async exibirMensagemErroSimplificada(informacao) {
      this.erroOriginal = informacao;
      this.erroFormatado = [{ erroFormatado: informacao, tagErro: informacao }];
      await this.modalErroNFe(true);
    },

    async modalErroNFe(exibir) {
      if (exibir === true) {
        this.exibirModalErroNFe = true;
        getOrCreateInstanceModal(
          "kt_modal_erro_nfe",
          /*open*/ () => {
            this.$utils.requestFocus("kt_modal_erro_nfe");
          },
          /*close*/ () => {
            this.modalErroNFe(false);
          }
        );
      } else {
        hideModalId("kt_modal_erro_nfe", () => {
          this.exibirModalErroNFe = false;
        });
      }
    },

    exibirEditarInutilizacaoNFeModal(exibir) {
      this.exibirModalInutilizacaoNFe = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_editar_inutilizacao_nfe_modal",
          /*open*/ () => {
            this.$utils.requestFocus("txtAno");
          },
          /*close*/ () => {
            this.exibirEditarInutilizacaoNFeModal(false);
          }
        );
      }
    },
    adicionarInutilizacaoNFe() {
      const dataAtual = new Date();
      const anoCompleto = dataAtual.getFullYear();
      const anoAbreviado = (anoCompleto % 100).toString();

      this.idInutilizacaoNFe = -1;
      this.refInutilizacaoNFeEdicao = {
        ano: anoAbreviado,
        modelo: "55",
        serie: "001",
        n_nf_ini: 0,
        n_nf_fin: 0,
        justificativa: "",
      };
      this.exibirEditarInutilizacaoNFeModal(true);
    },
    async editarInutilizacaoNFe(inutilizacao) {
      if (inutilizacao.cod_status != 102) {
        this.idInutilizacaoNFe = inutilizacao.id;
        this.exibirEditarInutilizacaoNFeModal(true);
      } else {
        await this.$swal.showInvalidAlert(
          "O status indica que a numeração já foi inutilizada e não pode ser excluída."
        );
      }
    },
    async removerInutilizacaoNFe(inutilizacao) {
      if (inutilizacao.cod_status != 102) {
        await this.$swal.showQuestionAlert(
          "Deseja remover o registro?",
          async (alert) => {
            if (alert.isConfirmed) {
              try {
                this.$refs.tabelaInutilizacoesNFe.setLoading(true);

                var ret = await this.$store.dispatch(
                  "inutilizacaoNFe/deleteInutilizacaoNFe",
                  inutilizacao.id
                );

                if (ret.Success == true) {
                  toast.success("Registro removido com sucesso!", {
                    timeout: 2000,
                  });
                  this.$refs.tabelaInutilizacoesNFe.load();
                }
              } catch (error) {
                console.log(error);
              }
              this.$refs.tabelaInutilizacoesNFe.setLoading(false);
            }
          }
        );
      } else {
        await this.$swal.showInvalidAlert(
          "O status indica que a numeração já foi inutilizada e não pode ser excluída."
        );
      }
    },
    async confirmarEditarInutilizacaoNFeModal() {
      this.$refs.tabelaInutilizacoesNFe.setLoading(true);
      this.$refs.tabelaInutilizacoesNFe.load();
    },
  },
  async mounted() {
    await this.verificarRestricoes();
    setTimeout(() => {
      this.nextFocus("txtPesquisarInutilizacoes");
    }, 800);
  },
  data() {
    return {
      loading: false,
      adicionar: false,
      editar: false,
      excluir: false,
      transmitir: false,
      errosValidacaoGeral: [],
      exibirModalErroNFe: false,
      erroOriginal: "",
      erroFormatado: "",
      mensagemLoading: "",
      exibirModalInutilizacaoNFe: false,
      refInutilizacaoNFeEdicao: {},
      idInutilizacaoNFe: -1,
      tableHeader: [
        {
          name: "ID",
          key: "id",
          sortable: true,
        },
        {
          name: "Situação",
          key: "situacao",
          sortable: false,
        },
        {
          name: "Ano",
          key: "ano",
          sortable: true,
        },
        {
          name: "Modelo",
          key: "modelo",
          sortable: true,
        },
        {
          name: "Série",
          key: "serie",
          sortable: true,
        },
        {
          name: "Nº inicial nota",
          key: "n_nf_ini",
          sortable: true,
        },
        {
          name: "Nº final nota",
          key: "n_nf_fin",
          sortable: true,
        },
        {
          name: "Justificativa",
          key: "justificativa",
          sortable: true,
        },
        {
          name: "Protocolo",
          key: "protocolo",
          sortable: true,
        },
        {
          name: "Cod. Status",
          key: "cod_status",
          sortable: true,
        },
        {
          name: "Desc. Status",
          key: "desc_status",
          sortable: false,
        },
        {
          name: "Data Inclusão",
          key: "createdAt",
          sortable: true,
        },
        {
          name: "Data Alteração",
          key: "updatedAt",
          sortable: true,
        },
        {
          name: "Ações",
          key: "acoes",
          sortable: false,
        },
      ],
      tableData: {
        store: "inutilizacaoNFe/getInutilizacaoNFeOData",
        selectOData:
          "?$select=id,ano,modelo,serie,n_nf_ini,n_nf_fin,justificativa,protocolo,desc_status,cod_status,createdAt,updatedAt&$orderby=id desc",
        filterOData: "",
        search: "",
      },
      tablePagination: {
        page: 1,
        rowsPerPage: 10,
      },
      pageSizes: ["5", "10", "15", "20", "30", "50", "100"],
    };
  },
};
</script>

<style></style>
